{
  "familyId": "STU-GRAFIEK",
  "questions": [
    {
      "id": "STU-GRAFIEK-001",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Een meteoroloog bekijkt de regenval. In welke maand regende het het meest?",
      "options": ["November", "Juli", "Maart", "September"],
      "correctAnswer": 0,
      "data": {
        "labels": ["Maart", "Juli", "September", "November"],
        "values": [45, 60, 55, 80],
        "title": "Regenval per maand (in mm)",
        "xLabel": "Maand",
        "yLabel": "Regenval (mm)"
      },
      "stimulusAids": [
        {
          "type": "bar_chart",
          "data": {
            "labels": ["Maart", "Juli", "September", "November"],
            "values": [45, 60, 55, 80],
            "title": "Regenval per maand (in mm)",
            "xLabel": "Maand",
            "yLabel": "Regenval (mm)",
            "label": "Staafgrafiek: regenval per maand"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Staafgrafiek lezen",
            "content": "Kijk naar de hoogte van elke staaf. De hoogste staaf heeft de grootste waarde. November heeft de hoogste staaf (80 mm).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_reading",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De meteoroloog vergelijkt de hoogte van alle staven en zoekt de hoogste. Maart = 45 mm, Juli = 60 mm, September = 55 mm, November = 80 mm. De hoogste staaf is November (80 mm) — in november regende het het meest.",
        "solutionSteps": [
          "Lees de waarde van elke staaf af: Maart = 45, Juli = 60, September = 55, November = 80",
          "Vergelijk de waarden en zoek de hoogste: 80 mm (November)"
        ],
        "distractorExplanations": {
          "0": "Goed! In november regende het het meest (80 mm).",
          "1": "Je dacht waarschijnlijk dat juli de meeste regen had. Maar juli had 60 mm — veel, maar niet het meest. November had 80 mm, dat is 20 mm meer. Onthoud: vergelijk altijd alle staven.",
          "2": "Je dacht waarschijnlijk dat maart het meest was. Maar maart had 45 mm regen — dat is juist het minst van alle maanden. Onthoud: de laagste staaf = het minst.",
          "3": "Je dacht waarschijnlijk dat september het meest was. Maar september had 55 mm, terwijl november 80 mm had. Onthoud: vergelijk alle staven voordat je kiest."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-002",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Een bibliothecaris houdt bij hoeveel boeken Emma leest. Hoeveel boeken las Emma in totaal?",
      "options": ["18", "6", "5", "7"],
      "correctAnswer": 0,
      "data": {
        "labels": ["Q1", "Q2", "Q3"],
        "values": [6, 5, 7],
        "title": "Aantal gelezen boeken per kwartaal",
        "xLabel": "Kwartaal",
        "yLabel": "Aantal boeken"
      },
      "stimulusAids": [
        {
          "type": "bar_chart",
          "data": {
            "labels": ["Q1", "Q2", "Q3"],
            "values": [6, 5, 7],
            "title": "Aantal gelezen boeken per kwartaal",
            "xLabel": "Kwartaal",
            "yLabel": "Aantal boeken",
            "label": "Staafgrafiek: gelezen boeken per kwartaal"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Totaal berekenen uit grafiek",
            "content": "Om het totaal te vinden, tel je alle waarden bij elkaar op: Q1 (6) + Q2 (5) + Q3 (7) = 18 boeken.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_calculation",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De bibliothecaris telt alle kwartalen bij elkaar op: Q1 = 6, Q2 = 5, Q3 = 7. Totaal: 6 + 5 + 7 = 18 boeken.",
        "solutionSteps": [
          "Lees de waarde van elke staaf af: Q1 = 6, Q2 = 5, Q3 = 7",
          "Tel alle waarden bij elkaar op: 6 + 5 + 7 = 18 boeken"
        ],
        "distractorExplanations": {
          "0": "Goed! Emma las in totaal 18 boeken (6 + 5 + 7 = 18).",
          "1": "Je dacht waarschijnlijk dat je maar één staaf hoeft af te lezen. Maar 6 is alleen het aantal boeken in Q1. Bij 'in totaal' moet je alle kwartalen optellen: 6 + 5 + 7 = 18. Onthoud: 'totaal' = alles bij elkaar optellen.",
          "2": "Je dacht waarschijnlijk dat je maar één staaf hoeft af te lezen. Maar 5 is alleen het aantal boeken in Q2. Bij 'in totaal' tel je alles op: 6 + 5 + 7 = 18. Onthoud: 'totaal' = alles bij elkaar optellen.",
          "3": "Je dacht waarschijnlijk dat je maar één staaf hoeft af te lezen. Maar 7 is alleen het aantal boeken in Q3. Bij 'in totaal' tel je alles op: 6 + 5 + 7 = 18. Onthoud: 'totaal' = alles bij elkaar optellen."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-003",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Een sportcoach bekijkt de favoriete sporten. Hoeveel meer leerlingen kiezen voetbal dan tennis?",
      "options": ["8", "12", "4", "20"],
      "correctAnswer": 0,
      "data": {
        "labels": ["Voetbal", "Tennis", "Zwemmen", "Hockey"],
        "values": [12, 4, 8, 6],
        "title": "Favoriete sport van groep 7",
        "xLabel": "Sport",
        "yLabel": "Aantal leerlingen"
      },
      "stimulusAids": [
        {
          "type": "bar_chart",
          "data": {
            "labels": ["Voetbal", "Tennis", "Zwemmen", "Hockey"],
            "values": [12, 4, 8, 6],
            "title": "Favoriete sport van groep 7",
            "xLabel": "Sport",
            "yLabel": "Aantal leerlingen",
            "label": "Staafgrafiek: favoriete sport groep 7"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verschil berekenen in grafiek",
            "content": "Om het verschil te vinden: lees eerst beide waarden af (voetbal = 12, tennis = 4). Trek dan af: 12 − 4 = 8 leerlingen meer.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_difference",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De sportcoach leest beide waarden af en berekent het verschil. Voetbal = 12 leerlingen, tennis = 4 leerlingen. Verschil = 12 − 4 = 8 leerlingen meer.",
        "solutionSteps": [
          "Lees voetbal af: 12 leerlingen",
          "Lees tennis af: 4 leerlingen",
          "Bereken het verschil: 12 − 4 = 8"
        ],
        "distractorExplanations": {
          "0": "Goed! Er kiezen 8 meer leerlingen voetbal dan tennis (12 − 4 = 8).",
          "1": "Je dacht waarschijnlijk dat 12 het antwoord is. Maar 12 is het totaal aantal leerlingen dat voetbal kiest, niet het verschil met tennis. Bij 'hoeveel meer' moet je aftrekken: 12 − 4 = 8. Onthoud: 'hoeveel meer' = aftrekken.",
          "2": "Je dacht waarschijnlijk dat 4 het verschil is. Maar 4 is het aantal leerlingen dat tennis kiest, niet het verschil. Het verschil is 12 − 4 = 8. Onthoud: lees beide waarden af en trek af.",
          "3": "Je dacht waarschijnlijk dat je moet optellen. Maar bij 'hoeveel meer' moet je aftrekken, niet optellen. 12 − 4 = 8, niet 12 + 4 = 16 (of 20). Onthoud: 'hoeveel meer' = aftrekken."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-004",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Een klimatoloog bekijkt de temperatuurgegevens. Welke conclusie kun je trekken?",
      "options": ["De temperatuur stijgt van januari tot juli.", "Het is in april het warmst.", "De temperatuur daalt elke maand.", "Januari en juli zijn even warm."],
      "correctAnswer": 0,
      "data": {
        "labels": ["Januari", "April", "Juli", "Oktober"],
        "values": [3, 10, 20, 11],
        "title": "Gemiddelde temperatuur per maand (°C)",
        "xLabel": "Maand",
        "yLabel": "Temperatuur (°C)"
      },
      "stimulusAids": [
        {
          "type": "bar_chart",
          "data": {
            "labels": ["Januari", "April", "Juli", "Oktober"],
            "values": [3, 10, 20, 11],
            "title": "Gemiddelde temperatuur per maand (°C)",
            "xLabel": "Maand",
            "yLabel": "Temperatuur (°C)",
            "label": "Staafgrafiek: gemiddelde temperatuur per maand"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Conclusie trekken uit grafiek",
            "content": "Kijk naar het verloop: januari (3°C) → april (10°C) → juli (20°C). De temperatuur stijgt van januari tot juli. Na juli daalt het weer: oktober (11°C).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_conclusion",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De klimatoloog zoekt het patroon in de grafiek. Januari = 3°C, april = 10°C, juli = 20°C, oktober = 11°C. Het patroon: 3 → 10 → 20 (stijgend) → 11 (dalend). De temperatuur stijgt van januari tot juli, en daalt daarna weer.",
        "solutionSteps": [
          "Lees alle waarden af: jan=3, apr=10, jul=20, okt=11",
          "Zoek het patroon: 3 → 10 → 20 (stijgend) → 11 (dalend)",
          "Conclusie: de temperatuur stijgt van januari tot juli"
        ],
        "distractorExplanations": {
          "0": "Goed! De temperatuur stijgt van 3°C (januari) naar 20°C (juli).",
          "1": "Je dacht waarschijnlijk dat april het warmst is. Maar april (10°C) is niet het warmst — juli (20°C) is de warmste maand. Onthoud: vergelijk altijd alle waarden voordat je een conclusie trekt.",
          "2": "Je dacht waarschijnlijk dat de temperatuur steeds daalt. Maar van januari tot juli stijgt de temperatuur juist (3 → 10 → 20). Alleen na juli daalt het. Onthoud: kijk naar het hele verloop.",
          "3": "Je dacht waarschijnlijk dat januari en juli gelijk zijn. Maar januari (3°C) en juli (20°C) zijn niet even warm — juli is 17°C warmer. Onthoud: lees de waarden zorgvuldig af."
        }
      }
    },
    {
      "id": "STU-GRAFIEK-005",
      "familyId": "STU-GRAFIEK",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_grafiek",
      "questionType": "bar_chart",
      "question": "Een schooldirecteur bekijkt de favoriete vakken. Welke twee vakken zijn samen even populair als wiskunde?",
      "options": ["Engels en tekenen", "Nederlands en tekenen", "Engels en Nederlands", "Gym en tekenen"],
      "correctAnswer": 0,
      "data": {
        "labels": ["Wiskunde", "Nederlands", "Engels", "Tekenen", "Gym"],
        "values": [10, 3, 6, 4, 8],
        "title": "Favoriete vak van groep 8",
        "xLabel": "Vak",
        "yLabel": "Aantal leerlingen"
      },
      "stimulusAids": [
        {
          "type": "bar_chart",
          "data": {
            "labels": ["Wiskunde", "Nederlands", "Engels", "Tekenen", "Gym"],
            "values": [10, 3, 6, 4, 8],
            "title": "Favoriete vak van groep 8",
            "xLabel": "Vak",
            "yLabel": "Aantal leerlingen",
            "label": "Staafgrafiek: favoriete vak groep 8"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Combinaties vergelijken",
            "content": "Wiskunde = 10 leerlingen. Zoek twee vakken die samen ook 10 zijn: Engels (6) + tekenen (4) = 10. ✓",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bar_chart_combination",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "De schooldirecteur zoekt twee vakken die samen 10 leerlingen hebben (even veel als wiskunde). Engels (6) + tekenen (4) = 10 ✓. Dat klopt!",
        "solutionSteps": [
          "Lees wiskunde af: 10 leerlingen",
          "Probeer combinaties: Engels (6) + tekenen (4) = 10 ✓",
          "Controleer: 10 = 10, dus Engels en tekenen zijn samen even populair als wiskunde"
        ],
        "distractorExplanations": {
          "0": "Goed! Engels (6) + tekenen (4) = 10, even veel als wiskunde (10).",
          "1": "Je dacht waarschijnlijk dat Nederlands en tekenen samen 10 zijn. Maar Nederlands (3) + tekenen (4) = 7, niet 10. Onthoud: reken altijd na voordat je kiest.",
          "2": "Je dacht waarschijnlijk dat Engels en Nederlands samen 10 zijn. Maar Engels (6) + Nederlands (3) = 9, niet 10. Onthoud: reken altijd na.",
          "3": "Je dacht waarschijnlijk dat gym en tekenen samen 10 zijn. Maar gym (8) + tekenen (4) = 12, dat is meer dan 10. Onthoud: reken altijd na."
        }
      }
    }
  ]
}